"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../hooks");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles() {
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem,
    setEndDirection = _useStylesUtils.setEndDirection;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors,
    fontFamily = _useContext.fontFamily,
    direction = _useContext.direction;
  var ccTaskManagerIframeStyle = (0, _react.useMemo)(function () {
    var ccTaskManagerIframe = (0, _css.css)({
      fontFamily: fontFamily,
      direction: direction,
      userSelect: 'none',
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      justifyContent: 'flexStart',
      alignItems: 'stretch',
      zIndex: 9999999999
    });
    var ccTaskManagerIframeTitle = (0, _css.css)({
      padding: "".concat(pxToRem(20), " ").concat(pxToRem(20), " 0 ").concat(pxToRem(20)),
      lineHeight: pxToRem(29),
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text,
      fontWeight: 'bold',
      span: {
        fontSize: pxToRem(24)
      }
    });
    var ccTaskManagerIframeContent = (0, _css.css)({
      position: 'relative',
      flex: 'auto',
      iframe: {
        border: 'none'
      }
    });
    var ccTaskManagerIframeCloseBtn = (0, _css.css)(_objectSpread(_objectSpread({
      position: 'absolute',
      top: pxToRem(10)
    }, setEndDirection(10)), {}, {
      zIndex: 1
    }));
    return {
      ccTaskManagerIframe: ccTaskManagerIframe,
      ccTaskManagerIframeTitle: ccTaskManagerIframeTitle,
      ccTaskManagerIframeContent: ccTaskManagerIframeContent,
      ccTaskManagerIframeCloseBtn: ccTaskManagerIframeCloseBtn
    };
  }, [direction, fontFamily, pxToRem, setEndDirection, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text]);
  return {
    'cc-TaskManager__iframe': ccTaskManagerIframeStyle.ccTaskManagerIframe,
    'cc-TaskManager__iframe__title': ccTaskManagerIframeStyle.ccTaskManagerIframeTitle,
    'cc-TaskManager__iframe__content': ccTaskManagerIframeStyle.ccTaskManagerIframeContent,
    'cc-TaskManager__iframe__close-btn': ccTaskManagerIframeStyle.ccTaskManagerIframeCloseBtn
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;